/**
 * Uploaded files (transfer slips, proof of delivery photos, PDFs). Any field of type
 * `file` holds the id `POST /api/files` returns; `GET /api/files/:id` serves it to
 * signed-in users.
 */
export interface StoredFile {
  id: string
  name: string
  /** MIME type, e.g. `image/jpeg` */
  type: string
  /** Bytes */
  size: number
}

/** What can be uploaded: photos from a phone camera and PDFs */
export const fileTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif', 'application/pdf'] as const

export const MAX_FILE_BYTES = 10 * 1024 * 1024

export const fileUrl = (id: string) => `/api/files/${encodeURIComponent(id)}`
